import { Action } from '@ngrx/store'

import { LoginTokenModel } from '../../../../api/identity/models/login-token-model'

export const LOGIN = '[Auth] Login'
export const LOGIN_SUCCESS = '[Auth] Login Success'
export const LOGIN_FAILURE = '[Auth] Login Failure'
export const REFRESH_TOKEN = '[Auth] Refresh token'
export const REFRESH_TOKEN_SUCCESS = '[Auth] Refresh token success'
export const REFRESH_TOKEN_FAILED = '[Auth] Refresh token failed'

export const LOGOUT = '[Auth] Logout'
export const LOGOUT_API = '[Auth] Logout api'
export const LOGOUT_COMMON = '[Auth] Logout common'
export const LOGOUT_SUCCESS = '[Auth] Logout success'

export const LOGIN_REDIRECT = '[Auth] Login Redirect'
export const LOGGED_IN_REDIRECT = '[Auth] LoggedIn Redirect'
export const FIRST_TIME_LOGIN_REDIRECT = '[Auth] First time login redirect'

export const SIGNIN_REDIRECT = '[Auth] Signin Redirect'
export const SIGNIN_SILENT_CALLBACK = '[Auth] Signin silent callback'

// Login
export class Login implements Action {
  readonly type = LOGIN
}

export class LoginSuccess implements Action {
  readonly type = LOGIN_SUCCESS

  constructor(public payload: LoginTokenModel) {
  }
}

export class LoginFailure implements Action {
  readonly type = LOGIN_FAILURE

  constructor(public payload: string) {
  }
}

export class RefreshToken implements Action {
  readonly type = REFRESH_TOKEN
}

export class RefreshTokenSuccess implements Action {
  readonly type = REFRESH_TOKEN_SUCCESS

  constructor(public payload: LoginTokenModel) {
  }
}

export class RefreshTokenFailed implements Action {
  readonly type = REFRESH_TOKEN_FAILED
}

// Redirects
export class LoginRedirect implements Action {
  readonly type = LOGIN_REDIRECT
}

export class LoggedInRedirect implements Action {
  readonly type = LOGGED_IN_REDIRECT
}

export class FirstTimeLoginRedirect implements Action {
  readonly type = FIRST_TIME_LOGIN_REDIRECT

  constructor(public payload: { email: string }) {
  }
}

// Logout
export class Logout implements Action {
  readonly type = LOGOUT

  constructor(public payload: { email?: string }) {
  }
}

export class LogoutApi implements Action {
  readonly type = LOGOUT_API
}

export class LogoutCommon implements Action {
  readonly type = LOGOUT_COMMON

  constructor(public payload: { query: any }) {
  }
}

export class LogoutSuccess implements Action {
  readonly type = LOGOUT_SUCCESS
}

export class SignInRedirect implements Action {
  readonly type = SIGNIN_REDIRECT

  constructor(public payload: {url: string} ) {
  }

}
export class SignInSilentCallback implements Action {
  readonly type = SIGNIN_SILENT_CALLBACK

  constructor(public payload: {url: string} ) {
  }

}

export type AuthActions =
  Login
  | LoginSuccess
  | LoginFailure
  | RefreshToken
  | RefreshTokenSuccess
  | RefreshTokenFailed
  | Logout
  | LogoutApi
  | LogoutCommon
  | LogoutSuccess
  | LoginRedirect
  | LoggedInRedirect
  | FirstTimeLoginRedirect
  | SignInRedirect
  | SignInSilentCallback



// WEBPACK FOOTER //
// ./src/app/shared/auth/store/actions/auth.actions.ts